// Version number - fetched from backend API on load
// Falls back to env variable or default if API fails
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';

// Function to fetch version from backend
export const fetchVersion = async (backendUrl, token) => {
  try {
    const response = await fetch(`${backendUrl}/api/version`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (response.ok) {
      const data = await response.json();
      return data.version || APP_VERSION;
    }
  } catch (error) {
    console.warn('Could not fetch version from API:', error);
  }
  return APP_VERSION;
};

// Build timestamp
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '2026-04-11';
